module.exports = __webpack_public_path__ + "static/img/Arama-Hau.8650d35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Arama-Hau.jpg
// module id = 6TeV
// module chunks = 0